module.exports = __webpack_public_path__ + "fonts/DINPro-CondMediIta.a21f3537.otf";